import Link from 'shopper/components/Link';
import Text from 'shopper/components/Text';

import { toLandingPageLink } from 'lib/links';

import LANDINGS from 'constants/landings';
import LINKS from 'constants/links';

const Disclaimer = () => (
  <Text className="text-center text-neutral-high-500" size="size3">
    Ao se cadastrar você declara que está ciente de nossa{' '}
    <Link
      className="text-rd-primary-700 dark:text-rd-primary-700"
      href={toLandingPageLink(
        'politica-de-privacidade',
        LANDINGS.TYPES.INSTITUTIONAL
      )}
      size="size3"
      target="_blank"
    >
      Política de Privacidade
    </Link>
    ,{' '}
    <Link
      className="text-rd-primary-700 dark:text-rd-primary-700"
      href={toLandingPageLink('termos', LANDINGS.TYPES.INSTITUTIONAL)}
      size="size3"
      target="_blank"
    >
      Termos de Uso
    </Link>{' '}
    e{' '}
    <Link
      className="text-rd-primary-700 dark:text-rd-primary-700"
      href={LINKS.COOKIES_POLICY}
      size="size3"
      target="_blank"
    >
      Política de Cookies
    </Link>
    .
  </Text>
);

export default Disclaimer;
